// Dear future developer. You might be tempted to code generate this interface.
// Do not do that. The code generated for resolvers is incompatible with front-
// end code, and will break the build.
interface SendRecognitionInput {
  coreValue?: string;
  isPublic?: boolean;
  message: string;
  points: number;
  recipients: (string | undefined)[];
  skills?: (
    | {
        id?: string;
        name?: string;
      }
    | undefined
  )[];
}

export const createPostRequestBody = (input: SendRecognitionInput) => {
  const { recipients, message, points, coreValue, skills, isPublic } = input;
  const mappedSkills = mapSkillsForYeiSplitJoinedHashes(skills);
  const postBody = {
    ["to_ids"]: recipients,
    message,
    points,
    skills: mappedSkills,
    ["company_tag_id"]: coreValue,
    privacy: isPublic ? "public" : "private",
  };
  if (!coreValue) {
    delete postBody["company_tag_id"];
  }
  return postBody;
};

/**
 * YEI does something truly bizarre inside the create post controller.
 *
 * If you send skills like so: [{id: "mongo-id-1", name: "skill one"}, {id: "mongo-id-2", name: "skill two"}, {id: "mongo-id-3", name: "skill three"}]
 *
 * YEI calls a function called `split_joined_hashes` that will split those into an array of length 6:
 * [{id: "mongo-id-1"}, {name: "skill one"}, {id: "mongo-id-2"}, {name: "skill two"}, {id: "mongo-id-3"}, {name: "skill three"}]
 * which will result in only mongo-id1 and mongo-id-2 being set as the skills because it also enforces the max skill limit of 3.
 *
 * Rather than remove the (split_joined_hashes)[https://github.com/KazooHR/web-legacy-rr/blob/fc09557cf78736341adbd36fd3dea2394bb95c6d/app/controllers/api/v3/posts_controller.rb] logic and risk breaking other places where that might be necessary
 * (it's been there for 5 years and I have no idea how many places would need QA to test it afterwards) this function will strip down the selected skills to play nice with
 * YEI's strange behavior.
 *
 * TLDR: if a skill has an existing ID we send {id: "mongo-id"}, otherwise we send raw name: {name: "skill name"}
 *
 * YEI will handle the lookup of the raw name and select an existing skill if there's already a match.
 */
export function mapSkillsForYeiSplitJoinedHashes(
  skills?: (
    | {
        id?: string;
        name?: string;
      }
    | undefined
  )[]
): ({ id: string } | { name: string })[] {
  // @ts-expect-error
  return skills
    ?.filter((skill) => Boolean(skill))
    ?.map((skill) => {
      return skill?.id ? { id: skill.id } : { name: skill?.name };
    });
}
